document.addEventListener("DOMContentLoaded", function () {
  const filterSelect = document.getElementById("category-filter");
  const empreendimentos = document.querySelectorAll(
    "#empreendimentos-list .empreendimento"
  );
  const loadingOverlay = document.getElementById("loading");

  filterSelect.addEventListener("change", function () {
    const selectedCategory = filterSelect.value;

    loadingOverlay.style.display = "flex";

    setTimeout(() => {
      empreendimentos.forEach((empreendimento) => {
        const categories = empreendimento
          .getAttribute("data-category")
          .split(" ");

        if (
          selectedCategory === "initial" ||
          categories.includes(selectedCategory)
        ) {
          empreendimento.style.display = "block";
        } else {
          empreendimento.style.display = "none";
        }
      });

      loadingOverlay.style.display = "none";
    }, 1000);
  });

  // Inicialmente exibir apenas 4 empreendimentos
  const allEmpreendimentos = Array.from(empreendimentos);
  allEmpreendimentos.forEach((empreendimento, index) => {
    if (index < 4) {
      empreendimento.style.display = "block";
    } else {
      empreendimento.style.display = "none";
    }
  });

  if (window.location.pathname == "/empreendimentos/") {
    empreendimentos.forEach((empreendimento) => {
      console.log(empreendimento);
      empreendimento.style.display = "block";
    });
  }
});
